(function () {

  'use strict';

  function pxTreeFolder() {
    return {
      require: '^^pxSitesTree',
      restrict: 'E',
      scope: {
        item: '='
      },
      templateUrl: 'app/components/sites/sitesTree/treeParts/treeFolder.template.html',
      link: function (scope, element, attrs, sitesTreeCtrl) {
        scope.sitesTreeCtrl = sitesTreeCtrl;
      }
    };
  }

  pxTreeFolder.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxTreeFolder', pxTreeFolder);

})();
